import React from 'react';
import MembersTemplate from '../../templates/Members/MembersTemplate';

export default function Members() {
  return <MembersTemplate />;
}
